// extracted by mini-css-extract-plugin
export default {"tariffDescription":"TariffDescription_tariffDescription__CfIDa"};